// Please refactor this file to use the new form meta system

import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

interface FormInputContactMeta {
    firstname: FormInputMeta;
    lastname: FormInputMeta;
    function: FormInputMeta;
    phone: FormInputMeta;
    email: FormInputMeta;
}

export interface IAddressFormMeta {
    addressType: FormInputMeta;
    address: FormInputMeta;
    city: FormInputMeta;
    street: FormInputMeta;
    postalCode: FormInputMeta;
    zone: FormInputMeta;
    state: FormInputMeta;
    phone1: FormInputMeta;
    phone2: FormInputMeta;
    fax: FormInputMeta;
    firstContactFirstname: FormInputMeta;
    firstContactLastname: FormInputMeta;
    firstContactFunction: FormInputMeta;
    firstContactPhone: FormInputMeta;
    firstContactEmail: FormInputMeta;
    secondContactFirstname: FormInputMeta;
    secondContactLastname: FormInputMeta;
    secondContactFunction: FormInputMeta;
    secondContactPhone: FormInputMeta;
    secondContactEmail: FormInputMeta;
    schema: any;
  }

const AddressFormMeta = {} as IAddressFormMeta;

AddressFormMeta.addressType = {
    label: 'Type addresse',
    name: 'addressType',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Adresse type A',
        value: 'a'
      },
      {
        label: 'Adresse type B',
        value: 'b',
      },
    ],
    validation: yup.string().required("This field is required"),
  }
AddressFormMeta.address = {
    name: "address",
    label: "Adresse",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.city = {
    ...commonFormMeta.city,
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.street = {
    name: "street",
    label: "Rue",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.postalCode = {
    name: "postalCode",
    label: "Code Postal",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.zone = {
    name: "zone",
    label: "Zone",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.state = {
    name: "state",
    label: "Etat",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.phone1 = {
    name: "phone1",
    label: "Téléphone 1",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.phone2 = {
    name: "phone2",
    label: "Téléphone 2",
    type: "text",
    validation: yup.string().required("This field is required"),
}
AddressFormMeta.fax = {
    name: "fax",
    label: "Fax",
    type: "text",
    validation: yup.string().required("This field is required"),
}

let contact : FormInputContactMeta = {
    firstname : {
        name: "firstname",
        label: "Nom",
        type: "text",
        validation: yup.string().required("This field is required"),
    },
    lastname : {
        name: "lastname",
        label: "Prénom",
        type: "text",
        validation: yup.string().required("This field is required"),
    },
    function : {
        name: "function",
        label: "Fonction",
        type: "text",
        validation: yup.string().required("This field is required"),
    },
    phone : {
        name: "phone",
        label: "Téléphone",
        type: "text",
        validation: yup.string().required("This field is required"),
    },
    email : {
        name: "email",
        label: "Email",
        type: "text",
        validation: yup.string().required("This field is required"),
    }
}

/** PREMIER CONTACT */

for(let key in contact) {
    let newKey = `firstContact${capitalize(key as keyof typeof contact)}`;
    AddressFormMeta[newKey as keyof typeof AddressFormMeta] = {
        ...contact[key as keyof typeof contact],
        name: `firstContact${capitalize(key as keyof typeof contact)}`
    }
}   

/** SECOND CONTACT */

for(let key in contact) {
    let newKey = `secondContact${capitalize(key as keyof typeof contact)}`;
    AddressFormMeta[newKey as keyof typeof AddressFormMeta] = {
        ...contact[key as keyof typeof contact],
        name: `secondContact${capitalize(key)}`
    }
}

AddressFormMeta.schema = yup.object().shape(getValidationSchema(AddressFormMeta));

export default AddressFormMeta;